import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


import { CmsBannerComponent, WindowRef, CmsService, SemanticPathService } from '@spartacus/core';
import { BannerComponent, CmsComponentData } from '@spartacus/storefront';
import { find } from 'rxjs/operators';

import { DpGtmService } from '@app/core/services/gtm.service';

@Component({
    selector: 'dp-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DpBannerComponent extends BannerComponent {
  data?: CmsBannerComponent;
  tracked = false;

  constructor(
    protected urlService: SemanticPathService,
    protected cmsService: CmsService,
    protected component: CmsComponentData<CmsBannerComponent>,
    private readonly winRef: WindowRef,
    private readonly dpGtmService: DpGtmService,
  ) {
    super(component, urlService, cmsService);
    this.component.data$
      .pipe(
        find((val) => !!val),
        takeUntilDestroyed(),
      )
      .subscribe((data) => (this.data = data));
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(): void {
    if (!this.data || this.tracked || this.data.uid === 'SiteLogoComponent') {
      return;
    }
    const bannerEl = this.winRef.document.getElementById((this.data.uid ?? 'unknown') + '_dpBanner');

    if (bannerEl) {
      const bounding = bannerEl.getBoundingClientRect();
      const categoryElHeight = bannerEl.offsetHeight;
      const categoryElWidth = bannerEl.offsetWidth;
      const doc = this.winRef.document.documentElement;
      const win = this.winRef.nativeWindow;

      if (
        bounding.top >= -categoryElHeight &&
        bounding.left >= -categoryElWidth &&
        bounding.right <= (win?.innerWidth || doc.clientWidth) + categoryElWidth &&
        bounding.bottom <= (win?.innerHeight || doc.clientHeight) + categoryElHeight
      ) {
        this.tracked = true;
        this.sendGTMTag('view_promotion');
      }
    }
  }

  clickOnPromotion(): void {
    this.sendGTMTag('select_promotion');
  }

  sendGTMTag(event: string): void {
    if (!this.data) {
      return;
    }
    const media = this.data.media;

    void this.dpGtmService.pushSimpleTag(event, {
      promotion_id: media && 'code' in media ? media.code : '',
      promotion_name: media && 'altText' in media ? media.altText : '',
      creative_name: this.data.name,
      creative_slot: this.data.uid,
    });
  }

  getTargetUrl(data: CmsBannerComponent): string | null {
    return super.getTarget(data);
  }
}
